const BACK_OFFICE_PREFIX = 'back-office';

export const routes = {
    home: '/',
    login: '/login',
    logout: '/logout',
    registration: '/signup',
    resetPassword: '/reset-password',
    profile: '/profile',
    address: '/commande/adresse',
    menu: '/menu-page',
    success: '/success',  // Ajout explicite de la route /success
    instructions: '/instructions',
    
    backOffice: {
        home: BACK_OFFICE_PREFIX,
        dashboard: `${BACK_OFFICE_PREFIX}/dashboard`,
        restaurantCreation: '/restaurants/creation',
        restaurantView: '/restaurants/view',
    }
}